import React from "react"

// markup
const IndexPage = ({ data }) => {
    return data.map((item, index) => (
        <div
            dangerouslySetInnerHTML={{
                __html: item.script,
            }}
            key={index}
        ></div>
    ))
}

export default IndexPage
